import {RULE_TYPE_CONTAINS, RULE_TYPE_EQUALS, RULE_TYPE_STARTS_WITH} from "../codes";

export const listToMap = (list, key) => {
  const res = {};

  list.forEach(item => res[item[key]] = item);

  return res;
}

export const getOrDefault = (value, valueIfUndefined) => value === undefined || value === null ? valueIfUndefined : value;

export const findRule = (transactionRules, payee) => {
  payee = payee.toUpperCase();

  return transactionRules.find(r => {
    const value = r.value.toUpperCase();

    if (r.type === RULE_TYPE_CONTAINS) {
      return payee.indexOf(value) > -1;
    } else if (r.type === RULE_TYPE_EQUALS) {
      return payee === value;
    } else if (r.type === RULE_TYPE_STARTS_WITH) {
      return payee.startsWith(value);
    } else {
      return payee.endsWith(value);
    }
  });
}

export const round = (number, decimals) => Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);

export const sortTransactionsAsc = (a, b) => {
  if (a.valueDate > b.valueDate) {
    return 1;
  } else if (a.valueDate < b.valueDate) {
    return -1;
  }

  return a.createTime.localeCompare(b.createTime);
}
